<template>
  <CFooter :fixed="false">
    <div>
      <!-- <a href="https://quizgiri.com.nd" target="_blank">Nagorik</a> -->
    </div>
    <div class="mfs-auto">
      <span class="mr-1" target="_blank">Powered by</span>
      <a href="https://nagorik.tech">Nagorik Tech {{ new Date().getFullYear() }} </a>
    </div>
  </CFooter>
</template>

<script>
export default {
  name: 'TheFooter'
}
</script>
